import React, { FC } from 'react';

import { Box, Stack } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { selectCompliance } from 'app/containers/Compliance/selectors';
import {
  ChakraMarkdown,
  DetailsIdentifier,
  ExpandableText,
  StackedHeader,
} from 'components/DataDisplay';
import { BorderedBox } from 'components/DataDisplay/Box/BorderedBox';
import { Drawer } from 'components/Overlay';

import { SubControlTable } from './SubControlTable';

interface Props {
  control: Record<string, any>;
  isOpen: boolean;
  onClose: () => void;
}

export const SubControlsDrawer: FC<Props> = props => {
  const { control, isOpen, onClose } = props;
  const { selectedBlueprint } = useSelector(selectCompliance);
  const compliance = control?.compliance ?? selectedBlueprint?.compliance;

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      header={
        <StackedHeader
          upper={compliance?.replace('_', ' ')}
          lower={'Control: ' + control?.control}
          type={compliance}
          iconFilled={false}
        />
      }
      styles={{
        content: { maxW: '100rem' },
        // The resource metadata drawer can open on top of this drawer from a
        // portal outside it; keep this drawer from locking scroll or trapping
        // focus so the metadata drawer's tables scroll and its selects open.
        drawer: { blockScrollOnMount: false, trapFocus: false },
      }}
      closeButton
      body={
        <Stack h="full" w="full" spacing={5}>
          <DetailsIdentifier
            label="Control Description"
            isInline={false}
            value={
              <ExpandableText noOfLines={3}>
                <ChakraMarkdown content={control?.control_description || '-'} />
              </ExpandableText>
            }
            spacing={2}
          />
          <BorderedBox flex={1} h="full" p={4}>
            <Box h="full" w="full">
              <SubControlTable control={control} rowIndex={-1} isExpanded />
            </Box>
          </BorderedBox>
        </Stack>
      }
    />
  );
};
